export default "__VITE_ASSET__7JuPgElb__"